import { EmbedKeyList } from "@/components/EmbedKeys/EmbedKeyList";

export function EmbedKeys() {
  return <EmbedKeyList />;
}
